export type WorkCategory = "电视剧" | "电影";
export type RoleType = "主演" | "配角";

export interface WorkItem {
  id: string;
  title: string;
  category: WorkCategory;
  year: number;
  roleType: RoleType;
  role: string;
  director: string;
  cast: string[];
  genres: string[];
  popularity: number;
  rating: number;
  synopsis: string;
  characterIntro: string;
  cover: string;
  stills: string[];
}

export const worksList: WorkItem[] = [
  {
    id: "tokyo-night-flight",
    title: "东京夜航",
    category: "电视剧",
    year: 2026,
    roleType: "主演",
    role: "白石凛",
    director: "绪方悠介",
    cast: ["佐佐木明希", "高濑慎一", "安藤里奈", "三浦亮太"],
    genres: ["悬疑", "律政", "都市"],
    popularity: 96,
    rating: 8.7,
    synopsis:
      "一桩被长期搁置的旧案重新浮出水面，女检察官白石凛在追查真相的过程中，逐渐发现自己所处的立场本身也充满裂缝。剧集以冷峻的都市夜景为底，讲述一个人如何在体制与良知之间保持清醒。",
    characterIntro:
      "白石凛是地检署最年轻的主办检察官，以冷静和几乎不近人情著称。她习惯用证据说话，却在一桩旧案里被迫面对无法被证据解释的部分。佐佐木明希以极克制的表演，呈现了这个人物从坚硬到松动的完整过程。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20tailored%20dark%20suit%20against%20a%20moody%20nighttime%20city%20bokeh%20background%2C%20muted%20cool%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20editorial%20magazine%20photography&width=600&height=800&seq=work-tokyo-night-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20scene%20of%20a%20woman%20in%20a%20dark%20suit%20walking%20through%20a%20rainy%20neon%20lit%20Tokyo%20street%20at%20night%2C%20cool%20muted%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20film%20still%20photography&width=1200&height=675&seq=work-tokyo-night-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20cinematic%20interior%20of%20an%20empty%20modern%20courthouse%20with%20tall%20windows%20and%20soft%20grey%20daylight%2C%20muted%20desaturated%20tones%2C%20editorial%20film%20still%2C%20restrained%20and%20tense%20atmosphere&width=1200&height=675&seq=work-tokyo-night-still-2&orientation=landscape",
    ],
  },
  {
    id: "memory-of-snow",
    title: "雪之记忆",
    category: "电影",
    year: 2026,
    roleType: "主演",
    role: "高桥雪",
    director: "林田澄子",
    cast: ["佐佐木明希", "中村苍", "藤井沙耶"],
    genres: ["剧情", "文艺", "公路"],
    popularity: 92,
    rating: 8.9,
    synopsis:
      "为了兑现一个年少时的承诺，高桥雪独自踏上了一段穿越雪国的旅途。一路上她遇见形形色色的人，也逐渐看清自己一直回避的往事。影片以大量的雪景与长镜头，讲述一场安静的告别。",
    characterIntro:
      "高桥雪安静、内向，习惯把心事藏在沉默里。她并非勇敢的人，却愿意为一个诺言走很远的路。佐佐木明希用极简的台词与细腻的身体语言，塑造了一个在风雪中慢慢学会与自己和解的女性。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20soft%20wool%20coat%20standing%20in%20gently%20falling%20snow%2C%20muted%20cool%20neutral%20tones%2C%20soft%20diffused%20winter%20light%2C%20editorial%20magazine%20photography&width=600&height=800&seq=work-snow-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20shot%20of%20a%20lone%20woman%20walking%20along%20an%20empty%20snow%20covered%20road%20between%20pine%20trees%2C%20soft%20overcast%20light%2C%20muted%20cool%20neutral%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-snow-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20cinematic%20interior%20of%20a%20small%20wooden%20train%20station%20with%20frosted%20windows%20and%20warm%20lamp%20light%2C%20muted%20neutral%20tones%2C%20editorial%20film%20still%2C%20nostalgic%20atmosphere&width=1200&height=675&seq=work-snow-still-2&orientation=landscape",
    ],
  },
  {
    id: "silent-coast",
    title: "寂静海岸",
    category: "电影",
    year: 2025,
    roleType: "主演",
    role: "佐伯澪",
    director: "金城浩",
    cast: ["佐佐木明希", "浅野琢磨"],
    genres: ["剧情", "家庭"],
    popularity: 88,
    rating: 8.6,
    synopsis:
      "在一座逐渐衰落的海边小镇，佐伯澪回到已故母亲的老屋整理遗物。面对熟悉的街道与陌生人般的邻居，她重新理解了母亲那一代人的沉默。影片几乎没有配乐，以海浪声贯穿始终。",
    characterIntro:
      "佐伯澪是一名在城市里工作的声音设计师，习惯用录音去理解世界。回到故乡后，她发现真正难以面对的，是自己与母亲之间那些从未说出口的话。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20poster%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20simple%20light%20dress%20standing%20against%20a%20pale%20overcast%20sea%20horizon%2C%20muted%20cool%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20editorial%20photography&width=600&height=800&seq=work-coast-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20shot%20of%20a%20quiet%20fishing%20town%20harbour%20at%20dawn%20with%20calm%20water%20and%20soft%20mist%2C%20muted%20desaturated%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-coast-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cinematic%20interior%20of%20an%20old%20seaside%20house%20with%20linen%20curtains%20and%20soft%20window%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20film%20still%2C%20intimate%20and%20still&width=1200&height=675&seq=work-coast-still-2&orientation=landscape",
    ],
  },
  {
    id: "spring-post",
    title: "春日邮便",
    category: "电视剧",
    year: 2023,
    roleType: "主演",
    role: "三上千夏",
    director: "大西一真",
    cast: ["佐佐木明希", "吉冈里央", "田中拓海"],
    genres: ["温情", "治愈", "生活"],
    popularity: 85,
    rating: 8.4,
    synopsis:
      "在小镇的邮局里，三上千夏负责投递那些地址已经模糊的信件。她用自己的方式把每一封信送回该去的地方，也慢慢疗愈了镇上人们的心事。",
    characterIntro:
      "三上千夏温柔而有耐心，认为每一封信背后都藏着一段没有说完的故事。这个角色让更多观众记住了佐佐木明希，也常被称为她最被喜爱的一次荧幕形象。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20poster%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20in%20a%20cream%20knit%20cardigan%20holding%20letters%2C%20soft%20spring%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-spring-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=nostalgic%20cinematic%20scene%20of%20a%20small%20town%20post%20office%20with%20wooden%20shelves%20and%20pastel%20mailboxes%2C%20soft%20daylight%2C%20muted%20warm%20neutral%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-spring-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=gentle%20cinematic%20shot%20of%20a%20cherry%20blossom%20lined%20suburban%20street%20in%20soft%20spring%20morning%20light%2C%20muted%20neutral%20pastel%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-spring-still-2&orientation=landscape",
    ],
  },
  {
    id: "ginza-dusk",
    title: "银座的黄昏",
    category: "电影",
    year: 2024,
    roleType: "配角",
    role: "田中美咲",
    director: "黑川诚",
    cast: ["北野绫子", "佐佐木明希", "大庭雪之"],
    genres: ["剧情", "女性"],
    popularity: 78,
    rating: 8.1,
    synopsis:
      "两位在同一家老茶馆工作多年的女性，在银座逐渐更迭的城市面貌中面对各自的人生选择。田中美咲是那段关系里看似游离、实则关键的一方。",
    characterIntro:
      "田中美咲外表洒脱、来去自由，却在关键节点成为串联两位主角的那条线。虽然是配角，佐佐木明希用不多却精准的戏份，让人物留下了清晰的轮廓。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20silk%20blouse%20in%20a%20vintage%20tea%20house%20interior%2C%20warm%20amber%20lamp%20light%2C%20muted%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-ginza-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cinematic%20evening%20street%20scene%20of%20old%20Ginza%20alleyways%20with%20warm%20lantern%20glow%2C%20muted%20amber%20neutral%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-ginza-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20cinematic%20interior%20of%20a%20traditional%20tea%20house%20with%20wooden%20counter%20and%20soft%20warm%20light%2C%20muted%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-ginza-still-2&orientation=landscape",
    ],
  },
  {
    id: "midnight-clinic",
    title: "深夜诊疗室",
    category: "电视剧",
    year: 2024,
    roleType: "主演",
    role: "蓝原汐里",
    director: "白石泰",
    cast: ["佐佐木明希", "冈田怜", "藤井沙耶"],
    genres: ["医疗", "悬疑", "都市"],
    popularity: 82,
    rating: 8.3,
    synopsis:
      "城市角落一间只在深夜营业的诊疗室，医生蓝原汐里接诊的都是无处可去的人。每一集都是一次深夜对话，也一点点拼出她自己的秘密。",
    characterIntro:
      "蓝原汐里话不多，却总能在最要紧的一句话上击中病人。她选择在深夜工作，是因为白天对她而言太过喧闹。角色兼具疏离感与温度，是佐佐木明希又一次细腻的表演。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20plain%20white%20coat%20in%20a%20dimly%20lit%20clinic%2C%20cool%20muted%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20editorial%20photography&width=600&height=800&seq=work-clinic-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20interior%20of%20a%20small%20night%20clinic%20with%20soft%20green%20exam%20light%20and%20empty%20chairs%2C%20cool%20muted%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-clinic-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cinematic%20night%20shot%20of%20a%20quiet%20city%20back%20street%20with%20a%20single%20glowing%20clinic%20sign%2C%20muted%20cool%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-clinic-still-2&orientation=landscape",
    ],
  },
  {
    id: "ultramarine",
    title: "群青",
    category: "电影",
    year: 2022,
    roleType: "主演",
    role: "佐野葵",
    director: "林田澄子",
    cast: ["佐佐木明希", "高濑慎一"],
    genres: ["剧情", "青春"],
    popularity: 74,
    rating: 8.0,
    synopsis:
      "海边的夏天，佐野葵在一间即将关闭的旧画室里度过了最后一个假期。她与过去、与一位重要的人告别，也第一次真正面对自己想成为什么样的人。",
    characterIntro:
      "佐野葵倔强而敏感，用画画来表达所有说不出口的情绪。这个角色让佐佐木明希第一次被文艺片观众记住，也开启了她之后一连串作者电影的路径。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20paint%20stained%20shirt%20in%20a%20sunlit%20old%20art%20studio%2C%20soft%20natural%20light%2C%20muted%20blue%20and%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-ultramarine-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cinematic%20summer%20scene%20of%20a%20bright%20empty%20art%20studio%20by%20the%20sea%20with%20open%20windows%2C%20soft%20natural%20light%2C%20muted%20blue%20neutral%20tones%2C%20film%20still&width=1200&height=675&seq=work-ultramarine-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=minimal%20cinematic%20shot%20of%20a%20sunlit%20sea%20horizon%20with%20gentle%20waves%2C%20muted%20blue%20neutral%20tones%2C%20editorial%20film%20still%2C%20calm%20atmosphere&width=1200&height=675&seq=work-ultramarine-still-2&orientation=landscape",
    ],
  },
  {
    id: "lost-testimony",
    title: "失落的证词",
    category: "电视剧",
    year: 2021,
    roleType: "配角",
    role: "神谷真央",
    director: "绪方悠介",
    cast: ["三浦亮太", "佐佐木明希", "安藤里奈"],
    genres: ["悬疑", "罪案"],
    popularity: 70,
    rating: 7.8,
    synopsis:
      "一桩十年悬案因一位关键证人而重开，神谷真央是当年唯一目睹真相的人。她的证词，将决定许多人的命运走向。",
    characterIntro:
      "神谷真央是那种被生活推着走的小人物，她的沉默既源于恐惧也源于善良。佐佐木明希在这个配角上展现了很强的内心张力。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20muted%20grey%20coat%20standing%20in%20a%20shadowed%20corridor%2C%20cool%20desaturated%20neutral%20tones%2C%20soft%20diffused%20lighting%2C%20editorial%20photography&width=600&height=800&seq=work-testimony-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20interior%20of%20an%20anonymous%20interview%20room%20with%20cold%20overhead%20light%2C%20cool%20desaturated%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-testimony-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20city%20street%20at%20dusk%20with%20reflections%20on%20wet%20pavement%2C%20muted%20cool%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-testimony-still-2&orientation=landscape",
    ],
  },
  {
    id: "after-rain-street",
    title: "雨后的街区",
    category: "电影",
    year: 2023,
    roleType: "配角",
    role: "小林知世",
    director: "金城浩",
    cast: ["浅野琢磨", "佐佐木明希"],
    genres: ["剧情", "生活"],
    popularity: 66,
    rating: 7.9,
    synopsis:
      "一场大雨过后，街区里几户人家的日常被轻轻串在一起。小林知世是串联这些故事的关键人物之一。",
    characterIntro:
      "小林知世独自经营着一家洗衣店，见证了街坊们的悲喜。她话少、动作利落，是那种把温柔藏在日常里的人。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20simple%20apron%20standing%20at%20a%20laundromat%20doorway%20after%20rain%2C%20soft%20diffused%20daylight%2C%20muted%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-rain-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cinematic%20quiet%20neighbourhood%20street%20glistening%20after%20rain%20with%20small%20shops%2C%20soft%20diffused%20light%2C%20muted%20neutral%20tones%2C%20film%20still&width=1200&height=675&seq=work-rain-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20interior%20of%20a%20small%20laundromat%20with%20spinning%20machines%20and%20soft%20light%2C%20muted%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-rain-still-2&orientation=landscape",
    ],
  },
  {
    id: "glass-wing",
    title: "玻璃之翼",
    category: "电视剧",
    year: 2020,
    roleType: "主演",
    role: "东云翼",
    director: "大西一真",
    cast: ["佐佐木明希", "滨田凛", "冈田怜"],
    genres: ["职场", "励志"],
    popularity: 63,
    rating: 7.7,
    synopsis:
      "东云翼是一名在玻璃工坊里坚持传统手艺的年轻匠人，面对现代化浪潮，她需要在传承与生存之间找到新的可能。",
    characterIntro:
      "东云翼对极致的工艺有近乎固执的追求，也因此屡屡与世界格格不入。角色让佐佐木明希展现了难得的热血与冲劲。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20work%20apron%20holding%20a%20glass%20piece%20in%20a%20warm%20workshop%2C%20soft%20light%20through%20windows%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-glass-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cinematic%20interior%20of%20a%20traditional%20glass%20workshop%20with%20glowing%20furnace%20and%20hanging%20tools%2C%20warm%20muted%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-glass-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=macro%20cinematic%20shot%20of%20translucent%20handmade%20glass%20objects%20catching%20soft%20light%2C%20muted%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-glass-still-2&orientation=landscape",
    ],
  },
  {
    id: "sanma-taste",
    title: "秋刀鱼的滋味",
    category: "电影",
    year: 2019,
    roleType: "配角",
    role: "中村千鹤",
    director: "黑川诚",
    cast: ["北野绫子", "中村苍", "佐佐木明希"],
    genres: ["家庭", "剧情"],
    popularity: 58,
    rating: 7.6,
    synopsis:
      "一家经营了三代的小食堂面临拆迁，中村千鹤是这家店里最年轻的厨师，也是唯一想留下的人。",
    characterIntro:
      "中村千鹤身上有一种笨拙的坚持，她把对家人的爱都放进了每一道菜里。这是佐佐木明希早期令人印象深刻的配角演出。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20an%20East%20Asian%20woman%20in%20a%20chef%20apron%20standing%20in%20a%20small%20warm%20family%20eatery%2C%20amber%20lamp%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-sanma-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cozy%20cinematic%20interior%20of%20a%20small%20family%20run%20diner%20with%20warm%20wooden%20counter%20and%20lamps%2C%20muted%20amber%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-sanma-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cinematic%20close%20up%20of%20simple%20home%20cooked%20japanese%20dishes%20on%20a%20wooden%20table%20in%20soft%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-sanma-still-2&orientation=landscape",
    ],
  },
  {
    id: "first-spring",
    title: "最初的春",
    category: "电影",
    year: 2018,
    roleType: "主演",
    role: "佐仓春",
    director: "大西一真",
    cast: ["佐佐木明希", "滨田凛"],
    genres: ["爱情", "剧情"],
    popularity: 61,
    rating: 7.5,
    synopsis:
      "佐仓春在大学毕业前夕遇见了改变她一生的人。这是一段关于第一次心动，也关于第一次学会放手的故事。",
    characterIntro:
      "佐仓春天真而勇敢，愿意为了喜欢的人一次次跨越距离。这个角色是佐佐木明希早期的重要转折，也让她的演技第一次获得大范围讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20portrait%20of%20a%20young%20East%20Asian%20woman%20in%20a%20soft%20pastel%20coat%20standing%20among%20spring%20flowers%2C%20gentle%20daylight%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20photography&width=600&height=800&seq=work-firstspring-cover&orientation=portrait",
    stills: [
      "https://readdy.ai/api/search-image?query=cinematic%20spring%20campus%20scene%20with%20blooming%20trees%20and%20soft%20warm%20light%2C%20muted%20pastel%20neutral%20tones%2C%20film%20still%20photography&width=1200&height=675&seq=work-firstspring-still-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20cinematic%20scene%20of%20a%20riverside%20path%20at%20sunset%20with%20soft%20golden%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20film%20still&width=1200&height=675&seq=work-firstspring-still-2&orientation=landscape",
    ],
  },
];